var _path, _path2, _path3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRecommend(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 58,
    viewBox: "0 0 36 58",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0H32V58L16 49L0 58V0Z",
    fill: "url(#paint0_linear_1788_10330)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.4012 27.9879V32.1806H9.7942V27.9879H11.4012ZM15.8857 27.53V28.8543H5.34565V27.53H15.8857ZM11.2172 22.9648C11.2172 23.6202 11.0287 24.2247 10.6516 24.7783C10.2775 25.332 9.73135 25.7988 9.01312 26.1789C8.29489 26.5559 7.44498 26.8028 6.4634 26.9195L5.87535 25.6492C6.70131 25.5534 7.40907 25.3649 7.99862 25.0836C8.59116 24.7993 9.03706 24.4701 9.33633 24.096C9.63858 23.7219 9.79121 23.3448 9.7942 22.9648V22.6775H11.2172V22.9648ZM11.4192 22.9648C11.4192 23.3389 11.5673 23.7129 11.8636 24.087C12.1629 24.4611 12.6073 24.7918 13.1968 25.0791C13.7894 25.3634 14.4971 25.5534 15.3201 25.6492L14.7365 26.9195C13.7549 26.8028 12.9065 26.5529 12.1913 26.1699C11.4761 25.7838 10.9299 25.3125 10.5528 24.7559C10.1758 24.1992 9.98722 23.6022 9.98722 22.9648V22.6775H11.4192V22.9648ZM14.9161 21.9458V23.2206H6.29731V21.9458H14.9161ZM11.4012 20.626V22.3857H9.7942V20.626H11.4012ZM20.5403 23.3329C20.5373 24.0511 20.4146 24.72 20.1722 25.3394C19.9298 25.9589 19.5647 26.4991 19.0769 26.9599C18.5921 27.4178 17.995 27.756 17.2858 27.9744L16.5002 26.7131C17.1047 26.5275 17.6105 26.2612 18.0175 25.914C18.4275 25.5669 18.7297 25.1718 18.9242 24.7289C19.1217 24.286 19.2205 23.8207 19.2205 23.3329V22.866H20.5403V23.3329ZM20.8365 23.3329C20.8365 23.7848 20.9353 24.2187 21.1328 24.6347C21.3303 25.0477 21.6326 25.4217 22.0396 25.7569C22.4496 26.0921 22.9568 26.3509 23.5613 26.5335L22.7847 27.7904C22.0755 27.5869 21.4755 27.2652 20.9847 26.8253C20.4969 26.3824 20.1303 25.8616 19.8849 25.2631C19.6395 24.6646 19.5183 24.0212 19.5213 23.3329V22.866H20.8365V23.3329ZM23.1618 21.9727V23.2476H16.8952V21.9727H23.1618ZM20.8545 20.6889V22.4665H19.2205V20.6889H20.8545ZM25.505 23.9972V25.2945H22.7847V23.9972H25.505ZM26.3175 20.626V29.191H24.7015V20.626H26.3175ZM26.5914 30.6633V31.9696H18.6504V30.6633H26.5914ZM20.2664 28.4593V31.5073H18.6504V28.4593H20.2664Z",
    fill: "#444E5E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M36 6L32 0V6H36Z",
    fill: "#B49001"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1788_10330",
    x1: 16,
    y1: 0,
    x2: 16,
    y2: 58,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCD05"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9809"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRecommend);
export default __webpack_public_path__ + "static/media/recommend.8f871c25dc0cf4c27a914dd13be766d4.svg";
export { ForwardRef as ReactComponent };